import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';

import {
    callRepayMentCashQry,
    callRayMentStockQry,
    callApplyRepayment,
    getFindBusinessTime,
} from '@api';
import { format } from 'date-fns';

const initialState = {
    certificateNumber: '',
    repayMentUuid: '',
    transType: '',
    transInfoVisible: true,
    certModalVisible: false,
    disableQueryInterest: false,
    repayMentDate: '',
    repayMentPartInterest: 0,
    repayMentAllInterest: '',
    repayMentPrincipal: '',
    repayMentTotalAmt: '',
    amount: '',
    mRate: '',
    payOffMoney: '', // 替代 repayMentPrincipal
    borrowingAmount: 0,
    applyModalVisible: false,
    stockApplyModalVisible: false,
    payOffComplete: false,
    applyDisabled: false,
    stockList: [
        {
            stockNo: '',
            stockName: '',
            qty: 0,
            closePrice: 0,
            marketVal: 0,
        },
    ],
    repaymentSwitchVisible: true,
    isLoading: false,
    loadingFailed: false,
    msg: '',
    transFlagModalVisible: false,
    TransMsg: '作業中，請稍後再申請！',
};
const api = {
    cashQry: callRepayMentCashQry,
    stockQry: callRayMentStockQry,
    applyRepayment: callApplyRepayment,
    getBusinessTime: getFindBusinessTime,
};
const PayOffStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getCustomerInfo() {},
        async getPayoffBusinessTime() {
            const res = await this.getBusinessTime();
            const transType = res.item.code;
            const repaymentSwitchMessage =
                res.item.switchOffMessage.repaymentSwitchMessage;
            this.assignData({ transType, repaymentSwitchMessage });
            if (transType === 'Y' || transType === '' || transType === 'E4') {
                this.updateData('transInfoVisible', true);
                this.updateData('applyDisabled', false);
            } else {
                this.updateData('transInfoVisible', false);
                this.updateData('applyDisabled', true);
            }
            const repaymentSwitch = res.item.switchOptions.repaymentSwitch;
            if (parseInt(repaymentSwitch)) {
                this.updateData('repaymentSwitchVisible', true);
                return parseInt(repaymentSwitch);
            } else {
                this.updateData('repaymentSwitchVisible', false);
                return parseInt(repaymentSwitch);
            }
        },
        async getCashQry(payOffMoney) {
            const postData = {
                repayMentAmt: payOffMoney,
            };
            const res = await this.cashQry(postData);
            const repayCashQry = res.data.item.repayMentCashUI;
            this.assignData({ ...repayCashQry });
            const stockRes = await this.stockQry();
            this.stockList = stockRes.data.items;
            this.disableQueryInterest = false;
        },
        // async getStockQry() {
        //     runInAction(async () => {
        //         const res = await this.stockQry();
        //         this.stockList = res.data.items.map(item => ({
        //             ...item,
        //             repaymentQty: 0,
        //         }));
        //     });
        // },
        async getApplyRepayment(
            account,
            // accountType,
            debitDeliveryBankAccount,
            borrowingAmount
        ) {
            // this.updateData('applyDisabled', true);
            this.updateData('isLoading', true);
            let postData = {};
            // if (this.payOffMoney) {
            // TODO 賣股還款功能判斷
            postData = {
                repayMentAddCash: {
                    account: account,
                    repayMentAccount: debitDeliveryBankAccount,
                    // repayMentAccountType: accountType,
                    repayMentAmount: this.payOffMoney,
                    repayMentDate: format(new Date(), 'yyyy/MM/dd'),
                    repayMentInterest: this.repayMentPartInterest,
                    trialCalculPercent: 0,
                },
                repayMentDetailId: this.repayMentUuid,
                certificateNumber: this.certificateNumber,
                repayType: 'c',
            };
            if (parseInt(this.payOffMoney) === borrowingAmount) {
                postData.repayMentAddCash.repayMentAmount = borrowingAmount;
                postData.repayMentAddCash.repayMentDate = format(
                    new Date(),
                    'yyyy/MM/dd'
                );
                postData.repayMentAddCash.repayMentInterest =
                    this.repayMentPartInterest;
            }
            // } else {
            //     postData = {
            //         repayMentAddStocks: this.stockList
            //             .filter(stock => stock.repaymentQty > 0)
            //             .map(
            //                 ({
            //                     closePrice,
            //                     stockNo,
            //                     repaymentQty,
            //                     stockName,
            //                 }) => ({
            //                     stockCode: stockNo,
            //                     stockName: stockName,
            //                     account,
            //                     closePrice,
            //                     collateralNumber: repaymentQty,
            //                     repayMentDate: format(new Date(), 'yyyy/MM/dd'),
            //                     trialCalculPercent: 0,
            //                 })
            //             ),
            //         repayType: 's',
            //     };
            // }
            const res = await this.applyRepayment(postData);
            const code = parseInt(res.data.code);
            const message = res.data.message;
            if (res) {
                this.updateData('applyDisabled', false);
                this.updateData('isLoading', false);
                this.updateData('payOffComplete', true);
                if (code) {
                    this.updateData('loadingFailed', true);
                    this.updateData('msg', message);
                }
            }
        },
        closeApplyModal() {
            this.applyModalVisible = false;
        },
        closeCertModal() {
            this.certModalVisible = false;
        },
        closeStockApplyModal() {
            this.stockApplyModalVisible = false;
        },
        setCount({ index, value }) {
            this.stockList[index].repaymentQty = value;
        },
        closeTransFlagModal() {
            this.transFlagModalVisible = false;
        },
    }));

export default PayOffStore;
